export { default } from './ContentBlock'